module.exports = __webpack_public_path__ + "img/6e09d53.jpg";